import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";


export const useSlowniki = (enabled = true) => {


    return useQuery({
        queryKey: ["slowniki_list"],
        queryFn: async () => getData('/slowniki'),
        enabled: enabled
    })
}